import { render, staticRenderFns } from "./Pageselect.vue?vue&type=template&id=35bbe079&scoped=true&"
import script from "./Pageselect.vue?vue&type=script&lang=js&"
export * from "./Pageselect.vue?vue&type=script&lang=js&"
import style0 from "./Pageselect.vue?vue&type=style&index=0&id=35bbe079&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bbe079",
  null
  
)

export default component.exports